import { render, staticRenderFns } from "./CotStrutturePrestazioniListComponent.vue?vue&type=template&id=63778586"
import script from "./CotStrutturePrestazioniListComponent.vue?vue&type=script&lang=js"
export * from "./CotStrutturePrestazioniListComponent.vue?vue&type=script&lang=js"
import style0 from "./CotStrutturePrestazioniListComponent.vue?vue&type=style&index=0&id=63778586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports